<template>
  <v-container v-if="roleAccess" class="management-tabs__container py-0 pb-16">
    <ParkingForm @getParking='getParking'/>
    <ParkingData @getParking='getParking'/>
  </v-container>
  <v-container v-else>
    <v-alert prominent type="error">
      <v-row align="center" class="my-0 py-5">
        <v-col class="grow">Access Denied by Role</v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>

<script>
  import ParkingForm from '@/components/parking/ParkingForm.vue';
  import ParkingData from '@/components/parking/ParkingData.vue';
  import api from '@/api/api';

  export default {
    name: 'Parking',
    components: {ParkingData, ParkingForm},

    mounted: async function () {
      // Google Analytics
      ga('set', 'page', '/management/parking');
      ga('send', 'pageview');
      // End Google Analytics
    },

    computed: {
      isAdmin: function () {
        return this.$store.getters.isAdmin;
      },
      roleAccess: function () {
        return (this.isAdmin);
      },
    },

    methods: {
      getParking: async function () {
        try {
          this.$store.commit('parking/updateParkingLoading', true);
          let {data} = await api.getParking();
          this.$store.commit('parking/updateParkingList', data || []);
          this.$store.commit('parking/updateParkingLoading', false);
        } catch (e) {
          this.$store.commit('parking/updateParkingLoading', false);
        }
      },
    },
  };
</script>
